var map = {
	"./oczymag1.jpg": 2565,
	"./oczymag2.jpg": 7936,
	"./oczymag3.jpg": 1250,
	"./oczymag4.jpg": 48,
	"./oczymag5.jpg": 8961,
	"assets/collections/editorials/oczymag/oczymag1.jpg": 2565,
	"assets/collections/editorials/oczymag/oczymag2.jpg": 7936,
	"assets/collections/editorials/oczymag/oczymag3.jpg": 1250,
	"assets/collections/editorials/oczymag/oczymag4.jpg": 48,
	"assets/collections/editorials/oczymag/oczymag5.jpg": 8961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5581;